/*
 * Conector del quiz con el carrito de la tienda (tema Shrine, base Dawn).
 * Agrega con un toque y abre el carrito lateral sin salir de la página.
 * Usa la misma API que el propio tema (cart-drawer.renderContents), con plan B a /cart.
 * Nada de lógica de promos: agrega a precio de lista; Kaching y los descuentos de Shopify hacen el resto.
 * 17-10: si Kaching Cart está activo, no pide las secciones del carrito de Shrine y abre el de Kaching (kachingCartApi.openCart).
 */
(function (global) {
  'use strict';

  function cajon() { return document.querySelector('cart-drawer'); }
  // 17-10: con Kaching Cart activo (borrador «Copia de 15-10-26»), el carrito que se abre es el de Kaching.
  function kaching() { return global.kachingCartApi && typeof global.kachingCartApi.openCart === 'function' ? global.kachingCartApi : null; }

  function abrirCarrito() {
    if (kaching()) { kaching().openCart(); return; }
    var d = cajon();
    if (d && typeof d.open === 'function') { d.open(); return; }
    global.location.href = (global.routes && global.routes.cart_url) || '/cart';
  }

  // Marca el carrito completo para atribuir la venta aunque la persona compre desde la ficha.
  function marcarCarrito(etiqueta) {
    return fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _ff_quiz: etiqueta } })
    }).catch(function () { /* la atribución no debe bloquear la compra */ });
  }

  function agregar(variantes, etiqueta) {
    var d = kaching() ? null : cajon();
    var cuerpo = { items: variantes.map(function (id) { return { id: Number(id), quantity: 1, properties: { _quiz: etiqueta } }; }) };
    if (d && typeof d.getSectionsToRender === 'function') {
      cuerpo.sections = d.getSectionsToRender().map(function (s) { return s.id; });
      cuerpo.sections_url = global.location.pathname;
    }
    var url = ((global.routes && global.routes.cart_add_url) || '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().then(function (datos) {
        if (!r.ok) throw new Error(datos.description || datos.message || 'No pudimos agregarlo.');
        return datos;
      });
    }).then(function (datos) {
      marcarCarrito(etiqueta);
      if (d && typeof d.renderContents === 'function' && datos.sections) {
        d.classList.remove('is-empty');
        d.renderContents(datos); // abre el carrito lateral con lo recién agregado
      } else {
        abrirCarrito();
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return datos;
    });
  }

  // Precio real de 1 unidad según Kaching: lo lee de la ficha (la app lo inserta ahí) y aplica su regla.
  // Misma lógica que quiz/kaching.mjs. Si algo falla, queda el precio de lista.
  function precioKachingDesdeHtml(html, lista) {
    var m = /<script[^>]*kaching-bundles-deal-block-settings[^>]*>([\s\S]*?)<\/script>/.exec(html);
    if (!m) return null;
    var cfg; try { cfg = JSON.parse(m[1]); } catch (e) { return null; }
    var barra = (cfg.dealBars || []).filter(function (b) { return (b.quantity || 1) === 1 && b.dealBarType !== 'bxgy'; })[0];
    if (!barra) return null;
    var v = Number(barra.discountValue) || 0;
    if (barra.discountType === 'percentage') return Math.round(lista * (1 - v / 100));
    if (barra.discountType === 'amount') return Math.max(0, lista - v);
    if (barra.discountType === 'specific') return v;
    return lista;
  }
  // Actualiza en el lugar los precios de las claves pedidas (productos = { clave: { url, precio, lista } }).
  function actualizarPrecios(productos, claves) {
    return Promise.all(claves.map(function (k) {
      var p = productos[k];
      if (!p || !p.url) return null;
      // Escalera nativa (ff-escalera.js): precio de 1 con lo que ya hay en el carrito. Sin ella, la regla de Kaching.
      var F = window.FFEscalera, h = /\/products\/([^/?#]+)/.exec(p.url);
      if (F && F.idDeHandle && h) {
        return F.idDeHandle(decodeURIComponent(h[1])).then(function (id) {
          var lista = p.lista || p.precio;
          if (!id || !F.familia(id)) return;
          var c = F.cotizar(id, lista, 1);
          if (c.pct > 0) { p.lista = lista; p.precio = c.total; }
        });
      }
      var guardado = null;
      try { guardado = JSON.parse(sessionStorage.getItem('ffq:kaching:' + k) || 'null'); } catch (e) { /* nada */ }
      if (guardado && Date.now() - guardado.ts < 10 * 60 * 1000) { p.lista = p.lista || p.precio; p.precio = guardado.precio; return null; }
      return fetch(p.url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var lista = p.lista || p.precio;
        var real = precioKachingDesdeHtml(html, lista);
        if (real != null) {
          p.lista = lista; p.precio = real;
          try { sessionStorage.setItem('ffq:kaching:' + k, JSON.stringify({ precio: real, ts: Date.now() })); } catch (e) { /* nada */ }
        }
      }).catch(function () { /* queda el precio de lista */ });
    }));
  }

  global.FFQuizTienda = { agregar: agregar, verCarrito: abrirCarrito, marcarCarrito: marcarCarrito, actualizarPrecios: actualizarPrecios };
})(window);
